import React from "react"
import { useAppSelector } from "../reducers/hooks"
import { selectUpdateAvailable } from "../reducers/appVersionSlice"
import cssUtils from "./utilsCss.module.css"
import { useTranslation } from "react-i18next"

const NotificationNewAppVersion = () => {
  const { t } = useTranslation()
  const updateAvailable = useAppSelector(selectUpdateAvailable)

  const fetchNewAppVersion = () => {
    window.location.reload()
  }

  if (!updateAvailable) return <></>

  if (updateAvailable) {
    window.appToaster.show(
      {
        message: t("app.newAppVersion.message"),
        icon: "info-sign",
        timeout: 0,
        intent: "primary",
        isCloseButtonShown: false,
        action: {
          text: t("app.newAppVersion.action"),
          onClick: fetchNewAppVersion,
          intent: "primary",
          className: cssUtils.underlineText,
        },
      },
      "newVersion",
    )
  }

  return <></>
}

export default NotificationNewAppVersion
